var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.contentIsValid
    ? _c(
        "div",
        { staticClass: "highlight-element highlight-description-container" },
        [
          _c("div", {
            staticClass: "highlight-description",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }